import {createRule, type Maybe} from '@regle/core';
import {isFilled} from '@regle/rules';
import {useTranslation} from '#imports';

const BIC_REGEXP = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

/**
 * BIC (Bank Identifier Code) / SWIFT code rule.
 *
 * Format: 4 letters (bank) + 2 letters (country) + 2 alphanumeric (location) + optional 3 alphanumeric (branch)
 *
 * @example
 * ```ts
 *  import { useRegle, bic } from '@malt/forms';
 *
 *  const { r$ } = useRegle(... , {
 *    bicCode: {bic}
 *  })
 * ```
 *
 * @see {@link https://en.wikipedia.org/wiki/ISO_9362 ISO 9362 - BIC/SWIFT}
 */
export const bic = createRule({
    type: 'bic',
    validator(value: Maybe<string>) {
        if (isFilled(value)) {
            return BIC_REGEXP.test(value);
        }
        return true;
    },
    message: () => {
        const {t} = useTranslation();
        return t('generic.forms.validation.errors.bic');
    },
});
